import React from 'react';
import { useTranslation } from 'react-i18next';

import { timeStringFormat } from '@/common/lib/timer';
import { StringMain } from '@/components/Typography/Typography';
import { MainButton } from '@/components/ui/Button/Button';
import { Loader } from '@/components/ui/Loader/Loader';

interface props {
  isWaitForClaim: boolean;
  waitResponse: boolean;
  timer: number;
  isClaimButtonActive: boolean;
}

const TaskButton: React.FC<props> = ({
  isWaitForClaim,
  waitResponse,
  timer,
  isClaimButtonActive,
}) => {
  const { t } = useTranslation();
  const [, minutes, seconds] = timeStringFormat(timer * 1000).split(':');

  return (
    <MainButton
      text=""
      className="h-full"
      inactive={isWaitForClaim}
      disabled={waitResponse || isWaitForClaim}
      isLoading={waitResponse}
    >
      {isWaitForClaim ? (
        <div className="flex items-center gap-2">
          <Loader className="!w-4 !h-4" />
          <StringMain className="!text-[10px] !font-[500]">
            {minutes}m : {seconds}s
          </StringMain>
        </div>
      ) : isClaimButtonActive ? (
        <StringMain className="!text-[14px] !font-[700]">
          {t('Claim')}
        </StringMain>
      ) : (
        <StringMain className="!text-[14px] !font-[700]">{t('Go')}</StringMain>
      )}
    </MainButton>
  );
};

export default TaskButton;
